import { NewPostage } from '../../../models/postage';
import { environment } from '../../../../environments/environment';
import { SelectAddressPage } from '../../../addresses/select-address/select-address.page';
import { SelectEmployeePage } from '../../../employees/select-employee/select-employee.page';
import { SQLService } from '../../../services/sql.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { Location } from '@angular/common';
@Component({
  selector: 'app-new-postage',
  templateUrl: './new-postage.component.html',
  styleUrls: ['./new-postage.component.scss'],
})
export class NewPostageComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public sql: SQLService,
    private location: Location,
    public modalController: ModalController
  ) {
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) {
        this.postage.enabled = true;
      }
    });
  }
  _c=0;
  postage = new NewPostage();
  currencies:any;
  end() {
    if (this._c>0) {
      if(confirm(this.sql.word.Discard_Confirmation)) {
        this.postage = new NewPostage();
        this.router.navigate(['folder','Settings']);
      }
    } else { 
      this.router.navigate(['folder','Settings']);
    }
  }

  delete_paypal() {
    if(!this.postage.postage_id){
      this.end();
    } else if(confirm(this.sql.word.Delete_Confirmation)) {
      this.sql.delete('Postage','postage_id',this.postage.postage_id,()=>{
        this._c=0;
        this.end();
      });
    }
  }
  save(end=true) {
    this.sql.add("Postage",this.postage,(a)=>{
      if(!a)return;
      if(end) {
        this.postage = new NewPostage();
        this._c=0;
        this.end();
      }
    });
  }
  update() { this.sql.update("Postage",this.postage); }
  get_postage() {
    let ida = this.route.snapshot.paramMap.get("id");
    if(!ida) return;
    this.sql.view('Postage','postage_id',ida,(e)=>{
      var f = Object.entries(e[0]); let n=new NewPostage();
      for( let t of f) n[t[0] ]=t[1]; this.postage = n;
    });
  }
  open() {
    this.currencies = Object.keys(environment.currencies);
    this.postage.enabled = true;
    this.get_postage();
  }
  ngOnInit() {
    this.open();
  }
}
